import { render, staticRenderFns } from "./TechShow.vue?vue&type=template&id=0d643b39&scoped=true&"
import script from "./TechShow.vue?vue&type=script&lang=js&"
export * from "./TechShow.vue?vue&type=script&lang=js&"
import style0 from "./TechShow.vue?vue&type=style&index=0&id=0d643b39&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d643b39",
  null
  
)

export default component.exports